/**
 * ProjectChat - Chat panel wrapper for Project page.
 *
 * Currently renders PRDGenerator for PRD generation.
 * Can be extended to support different chat modes in the future.
 */

import { JSX } from 'react';

import { PRDGenerator } from './PRDGenerator';

interface ProjectChatProps {
  existingPRD?: string;
  onSavePRD?: (prdContent: string) => void;
  projectDetails?: string;
  projectId?: string;
  projectName?: string;
}

export function ProjectChat(props: ProjectChatProps): JSX.Element {
  const { existingPRD, onSavePRD, projectDetails, projectId, projectName } = props;

  // Don't render PRDGenerator for temp projects (not yet saved to backend)
  const isTempProject = projectId?.startsWith('temp-');

  if (!projectId || !projectName || isTempProject) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center text-muted">
          <p className="text-sm">
            {isTempProject
              ? 'Save the project to start generating PRD'
              : 'Select a project to start generating PRD'}
          </p>
        </div>
      </div>
    );
  }

  return (
    <PRDGenerator
      existingPRD={existingPRD}
      onSavePRD={onSavePRD}
      projectDetails={projectDetails}
      projectId={projectId}
      projectName={projectName}
    />
  );
}
